import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';

import enUS from '~/i18n/en-US.json';

const useLocalI18nStaticData =
  process.env.NODE_ENV === 'development' ||
  process.env.NEXT_PUBLIC_USE_LOCAL_I18N === 'true';

const enableTolgeeDevTools = process.env.NEXT_PUBLIC_TOLGEE_DEVTOOLS === 'true';

export const createTolgeeInstance = () => {
  const tolgeeBuilder = useLocalI18nStaticData
    ? Tolgee().use(FormatIcu())
    : Tolgee()
        .use(
          BackendFetch({
            prefix: 'https://cdn.tolg.ee/5f2c6c044e797150ebfcb49fc994870b',
          })
        )
        .use(FormatIcu());

  const withDevTools =
    enableTolgeeDevTools && !useLocalI18nStaticData
      ? tolgeeBuilder.use(DevTools())
      : tolgeeBuilder;

  const tolgee = withDevTools.init({
    defaultLanguage: 'en-US',
    staticData: {
      'en-US': enUS,
    },
    ...(useLocalI18nStaticData
      ? {}
      : {
          apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
          apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
        }),
  });

  tolgee.on('error', error => {
    console.warn('Tolgee fetch error:', error);
  });

  return tolgee;
};

let browserTolgee: ReturnType<typeof createTolgeeInstance> | undefined;

export const getBrowserTolgee = () => {
  if (!browserTolgee) {
    browserTolgee = createTolgeeInstance();
  }
  return browserTolgee;
};
